module.exports = __webpack_public_path__ + "img/save_outlined_24.8b37acda.svg";